import React, { useContext, useEffect, useState } from "react";
// import "./Edit_User_Modal.css";
import { Button, Form, Modal } from "react-bootstrap";
import Modal_Heading from "../../Common_Component/Modal_Heading/Modal_Heading";
import Edit_User_Modal_Frame from "../../Common_Component/Common_Modal/Edit_User_Modal/Edit_User_Modal_Frame/Edit_User_Modal_Frame";
import { Update, findOne } from "../../../utils/apis/master/appsetup/index";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { HTTPS } from "../../../utils/common";
import { Context } from "../../../utils/context";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";

function Edit(props) {
  const { UnauthorizedLogOut, IMG_URL } = useContext(Context);
  const id = props.show;
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
    watch,
    getValues,
  } = useForm();

  // const image = watch("image");
  const logo_image = watch("logo_image");

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          // key === "image" ||
          if (key === "logo_image" && data[key][0]) {
            sendData.append(key, data[key][0]);
          } else {
            sendData.append(key, data[key]);
          }
        }
      }

      const result = await Update(id, sendData);
      const response = result.data;

      if (HTTPS.ALREADY_REPORTED.code !== response?.code) {
        await setShowModal({
          code: response.code,
          message: response.message,
        });
        setTimeout(() => {
          setShowModal(0);
          props.onHide();
        }, 1000);
      } else {
        for (const key in response.errors) {
          if (response.errors.hasOwnProperty(key)) {
            setError(key, {
              message: response.errors[key].msg,
            });
          }
        }
        // setError("name", {
        //   message: response?.errors?.name?.msg,
        // });
      }
    } catch (error) {
      for (const key in error?.response?.data?.errors) {
        if (error?.response?.data?.errors.hasOwnProperty(key)) {
          setError(key, {
            message: error?.response?.data?.errors[key].msg,
          });
        }
      }
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  const GetEditData = async () => {
    if (id) {
      const response = await findOne(id);
      reset(response?.data?.data);
    }
  };
  useEffect(() => {
    GetEditData();
  }, [id]);

  return (
    <>
      <section>
        <Modal
          {...props}
          className="Edit_User_Modal modal_holder"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered>
          <Modal_Heading modalHeading={"Edit App Set Up"} />
          <div className="modal-body-holder">
            {/* <Edit_User_Modal_Frame /> */}
            <Modal.Body>
              <div className="main-form-holder">
                <Form className="form-holder" onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>Version * </Form.Label>
                        <Form.Control
                          type="text"
                          name="version"
                          placeholder="Version"
                          className={classNames("", {
                            "is-invalid": errors?.version,
                          })}
                          {...register("version", {
                            required: "Version is required",
                            // pattern: {
                            //   value: /^\d+\.\d+\.\d+$/, // Regex for version format (e.g., 1.0.0)
                            //   message:
                            //     "Invalid version format. Use X.Y.Z (e.g., 1.0.0)",
                            // },
                          })}
                        />{" "}
                        <Form.Label className="">
                          Format. Use X.Y.Z (e.g., 1.0.0)
                        </Form.Label>
                        <br className="m-0 p-0" />
                        {errors.version && (
                          <span className="text-danger ">
                            {errors.version.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>Email *</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder="Email"
                          className={classNames("", {
                            "is-invalid": errors?.email,
                          })}
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value:
                                /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                              message: "Enter a valid email address",
                            },
                          })}
                        />
                        {errors.email && (
                          <span className="text-danger">
                            {errors.email.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>Support Contact No *</Form.Label>
                        <Form.Control
                          type="number"
                          name="support_contact_no"
                          placeholder="Support Contact No"
                          className={classNames("", {
                            "is-invalid": errors?.support_contact_no,
                          })}
                          {...register("support_contact_no", {
                            required: "Support Contact No is required",
                            // pattern: {
                            //   value: /^[0-9]+$/, // only numbers
                            //   message: "Only digits are allowed",
                            // },
                            // minLength: {
                            //   value: 10,
                            //   message: "Contact No must be exactly 10 digits",
                            // },
                            // maxLength: {
                            //   value: 10,
                            //   message: "Contact No must be exactly 10 digits",
                            // },
                          })}
                        />
                        {errors.support_contact_no && (
                          <span className="text-danger">
                            {errors.support_contact_no.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    {/* Deposit Bonus Amount */}
                    <div className="col-md-6 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="deposit_bonus_amount"
                      >
                        <Form.Label>Deposit Bonus Amount *</Form.Label>

                        <Form.Control
                          type="number"
                          name="deposit_bonus_amount"
                          placeholder="Enter Deposit Bonus Amount"
                          min="0"
                          step="0.01"
                          className={classNames("", {
                            "is-invalid": errors?.deposit_bonus_amount,
                          })}
                          {...register("deposit_bonus_amount", {
                            required: "Deposit Bonus Amount is required",
                            min: {
                              value: 0,
                              message: "Deposit Bonus Amount cannot be less than 0",
                            },
                            validate: (value) =>
                              Number(value) >= 0 ||
                              "Deposit Bonus Amount cannot be less than 0",
                          })}
                        />

                        {errors.deposit_bonus_amount && (
                          <span className="text-danger">
                            {errors.deposit_bonus_amount.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    {/* Deposit Bonus Percent */}
                    <div className="col-md-6 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="deposit_bonus_percent"
                      >
                        <Form.Label>Deposit Bonus Percent *</Form.Label>

                        <Form.Control
                          type="number"
                          name="deposit_bonus_percent"
                          placeholder="Enter Bonus Percentage"
                          min="0"
                          max="100"
                          step="0.01"
                          className={classNames("", {
                            "is-invalid": errors?.deposit_bonus_percent,
                          })}
                          {...register("deposit_bonus_percent", {
                            required: "Deposit Bonus Percent is required",
                            min: {
                              value: 0,
                              message: "Bonus percentage cannot be less than 0%",
                            },
                            max: {
                              value: 100,
                              message: "Bonus percentage cannot be more than 100%",
                            },
                            validate: (value) => {
                              const percent = Number(value);

                              if (percent < 0) {
                                return "Bonus percentage cannot be less than 0%";
                              }

                              if (percent > 100) {
                                return "Bonus percentage cannot be more than 100%";
                              }

                              return true;
                            },
                          })}
                        />

                        {errors.deposit_bonus_percent && (
                          <span className="text-danger">
                            {errors.deposit_bonus_percent.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>


                  </div>
                </Form>

                <div className="modal-footer-holder">
                  <div className="d-flex justify-content-center align-items-center">
                    <Button
                      className="search-btn mx-2"
                      onClick={() => {
                        props.onHide();
                        reset();
                      }}>
                      Cancel
                    </Button>

                    <Button
                      className="reset-btn mx-2"
                      type="button"
                      onClick={handleSubmit(onSubmit)}>
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </div>
        </Modal>
        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section>
    </>
  );
}

export default Edit;
